import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'warning-thin-icon',
  templateUrl: './warning-thin-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class WarningThinIconComponent {}
